/**
 * IONLOOP Assistant — query normalizer.
 *
 * Deterministic normalization of user questions before matching.
 * The original query (for display) is never modified; only the returned
 * normalized string is used for retrieval.
 */

const APOSTROPHES = /[\u2018\u2019\u02BC\u2032\u201A]/g;
const DOUBLE_QUOTES = /[\u201C\u201D\u201E]/g;
const DASHES = /[\u2013\u2014\u2212\u2010\u2011]/g;
const CURRENCY = /[$€£¥]/g;
const NON_ALNUM = /[^a-zA-Z0-9\s!?.,:'-]/g;

/**
 * Normalize a raw user question for matching.
 *
 *   "How can I START trading on IONLOOP??"
 *   → "how can i start trading on ionloop"
 *
 * Keeps meaningful tokens (numbers, product names) intact.
 */
function normalizeQuery(raw) {
    if (typeof raw !== 'string') {
        return '';
    }
    let q = raw;
    q = q.replace(APOSTROPHES, "'");
    q = q.replace(DOUBLE_QUOTES, '"');
    q = q.replace(DASHES, '-');
    q = q.replace(CURRENCY, ' ');
    q = q.replace(NON_ALNUM, ' ');
    q = q.toLowerCase();
    q = q.replace(/\s+/g, ' ').trim();

    // Collapse repeated punctuation.
    q = q.replace(/([!?.,:]){2,}/g, '$1');

    // Trim leading/trailing punctuation.
    q = q.replace(/^[^a-z0-9]+/g, '').replace(/[^a-z0-9]+$/g, '');

    // Polite / filler prefixes.
    q = q.replace(/^(please|pls|hey|hi|hello|yo)\s+/g, '');
    q = q.replace(/^(can you|could you|would you|will you|do you)\s+/g, '');

    return q.trim();
}

/**
 * Remove conversational noise that adds nothing to matching while keeping
 * structural words that signal intent (how, what, where, can, does...).
 */
function stripFillerPrefix(raw) {
    if (typeof raw !== 'string') {
        return '';
    }
    return raw
        .replace(/^(i would like to know|i want to know|i need to know|can you tell me|could you tell me|please tell me|tell me)\s+/g, '')
        .trim();
}

module.exports = {
    normalizeQuery,
    stripFillerPrefix
};
